<h2 class="mat-dialog-title" mat-dialog-title class="text-secondary">Delete Absence</h2>
<mat-dialog-content>
    <p class="text-center m-0 h3">Are you sure you would like to delete this absence?</p>
    <p class="text-center m-0 h3">Date: {{dialogDataInstance.absence_date | date: 'MM/dd/yy'}}</p>
    <p class="text-center m-0 h3">Tutor:
        {{
        getFullName(dialogDataInstance?.volunteer_first_name,dialogDataInstance?.volunteer_second_name,dialogDataInstance?.volunteer_last_name)
        | titlecase }}</p>
    <p class="text-center m-0 h3">Lesson: {{dialogDataInstance.lesson_plan_number}} - {{dialogDataInstance.lesson_plan_name}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close (click)="dialogRef.close(false)">Cancel</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true" (click)="dialogRef.close(true)" cdkFocusInitial>Yes</button>
</mat-dialog-actions>